import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from './SEOHead';

/**
 * NoIndexRoute — used for previously thin/programmatic route patterns that
 * Google flagged as "Page with redirect" or "Crawled - currently not indexed".
 *
 * These routes now:
 *   - Emit <meta name="robots" content="noindex, nofollow">
 *   - Have been REMOVED from the sitemap
 *   - Render a compact CTA that redirects intent to a real content pillar page
 *
 * Google will drop them from the index within a few crawls.
 */
const NoIndexRoute = ({
  goto = '/loyalty',
  gotoLabel = 'Explore Fundle Loyalty',
  headline = 'This page has moved',
  body = 'We consolidated our loyalty resources into a single, deeper knowledge hub. Continue there for platform, industry and strategy content.',
  title,
}) => (
  <div className="min-h-[70vh] flex items-center justify-center px-6 py-24 fai-darker font-sans">
    <SEOHead
      title={title || (headline === 'Page not found' ? 'Page not found · Fundle.ai' : 'Content moved · Fundle.ai')}
      description="This resource has been consolidated. Continue to Fundle.ai."
      noindex
    />
    <div className="max-w-xl w-full text-center">
      <p className="text-[10px] uppercase tracking-[0.28em] font-bold text-white/45 mb-4">Fundle · Loyalty</p>
      <h1 className="text-3xl sm:text-4xl text-white font-medium tracking-tight leading-[1.1] mb-4" style={{ letterSpacing: '-0.02em' }}>
        {headline}
      </h1>
      <p className="text-[15px] text-white/65 leading-relaxed font-light mb-8">{body}</p>
      <Link
        to={goto}
        className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black text-[13px] font-bold rounded-sm hover:bg-white/90"
        data-testid="noindex-cta"
      >
        {gotoLabel} →
      </Link>
    </div>
  </div>
);

export default NoIndexRoute;
